module.exports = __webpack_public_path__ + "img/knus_gallery3.17bab603.jpg";